import { el, qs } from "../../utils/dom";

export function toast(msg: string, type: "info" | "error" = "info") {
    const host = qs("#toasts");

    const icon = type === "error"
        ? el("span", {
            style: "font-weight: bold; color: white; background: #dc2626; border-radius: 50%; width: 16px; height: 16px; display: inline-flex; align-items: center; justify-content: center; font-size: 12px; margin-right: 8px;"
          }, "×")
        : null;

    const t = el("div", {
        class: `toast ${type === "error" ? "toast-error" : ""}`,
        style: type === "error"
            ? "background: #dc2626; color: white; border: 1px solid #b91c1c;"
            : ""
    });

    if (icon) t.appendChild(icon);
    t.appendChild(el("span", {}, msg));

    host.appendChild(t);
    setTimeout(() => t.remove(), type === "error" ? 5000 : 2500);
}

export function errorToast(msg: string) {
    console.error("❌", msg);
    toast(msg, "error");
}

export function infoToast(msg: string) {
    console.info("ℹ️", msg);
    toast(msg, "info");
}